(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[69625],{

/***/ 25508:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/setup",
      function () {
        return __webpack_require__(72400);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 72400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ TailwindCli; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/layouts/DocumentationLayout.js
var DocumentationLayout = __webpack_require__(53339);
// EXTERNAL MODULE: ./src/layouts/InstallationLayout.js
var InstallationLayout = __webpack_require__(44794);
// EXTERNAL MODULE: ./src/components/Cta.js
var Cta = __webpack_require__(64673);
// EXTERNAL MODULE: ./src/components/Steps.js + 1 modules
var Steps = __webpack_require__(49289);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/ClassTable.js + 2 modules
var components_ClassTable = __webpack_require__(65715);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/usePrevNext.js
var hooks_usePrevNext = __webpack_require__(76587);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./src/layouts/SidebarLayout.js
var layouts_SidebarLayout = __webpack_require__(21744);
// EXTERNAL MODULE: ./src/components/PageHeader.js
var components_PageHeader = __webpack_require__(58);
// EXTERNAL MODULE: ./src/components/Footer.js
var Footer = __webpack_require__(66278);
// EXTERNAL MODULE: ./src/components/Heading.js + 1 modules
var components_Heading = __webpack_require__(5679);
// EXTERNAL MODULE: ./node_modules/@mdx-js/react/dist/esm.js
var esm = __webpack_require__(3905);
// EXTERNAL MODULE: ./src/partials/Cta2.js
var Cta2 = __webpack_require__(46745);
// EXTERNAL MODULE: ./src/partials/DocsNewsletter.js
var partials_DocsNewsletter = __webpack_require__(45898);
;// CONCATENATED MODULE: ./src/layouts/SetupPageLayout.js


















var ContentsContext = /*#__PURE__*/ (/* unused pure expression or super */ null && (createContext()));
function TableOfContents(param) {
    var tableOfContents = param.tableOfContents, currentSection = param.currentSection;
    var closeNav = function closeNav() {
        if (isMainNav) {
            sidebarContext.setNavIsOpen(false);
        }
    };
    var sidebarContext = useContext(SidebarContext);
    var isMainNav = Boolean(sidebarContext);
    function isActive(section) {
        if (section.slug === currentSection) {
            return true;
        }
        if (!section.children) {
            return false;
        }
        return section.children.findIndex(isActive) > -1;
    }
    var pageHasSubsections = tableOfContents.some(function(section) {
        return section.children.length > 0;
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("h5", {
                className: "text-gray-900 font-semibold mb-4 text-sm leading-6",
                children: "On this page"
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: "text-gray-700 text-sm leading-6",
                children: tableOfContents.map(function(section) {
                    return /*#__PURE__*/ _jsxs(Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: "#".concat(section.slug),
                                    onClick: closeNav,
                                    className: clsx("block py-1", pageHasSubsections ? "font-medium" : "", isActive(section) ? "font-medium text-color10" : "hover:text-gray-900"),
                                    children: section.title
                                })
                            }),
                            section.children.map(function(subsection) {
                                return /*#__PURE__*/ _jsx("li", {
                                    className: "ml-4",
                                    children: /*#__PURE__*/ _jsxs("a", {
                                        href: "#".concat(subsection.slug),
                                        onClick: closeNav,
                                        className: clsx("group flex items-start py-1", isActive(subsection) ? "text-color10" : "hover:text-gray-900"),
                                        children: [
                                            /*#__PURE__*/ _jsx("svg", {
                                                width: "3",
                                                height: "24",
                                                viewBox: "0 -9 3 24",
                                                className: "mr-2 text-gray-400 overflow-visible group-hover:text-gray-600",
                                                children: /*#__PURE__*/ _jsx("path", {
                                                    d: "M0 0L3 3L0 6",
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round"
                                                })
                                            }),
                                            subsection.title
                                        ]
                                    })
                                }, subsection.slug);
                            })
                        ]
                    }, section.slug);
                })
            })
        ]
    });
}
function useTableOfContents(tableOfContents) {
    var ref;
    var ref1 = useState((ref = tableOfContents[0]) === null || ref === void 0 ? void 0 : ref.slug), currentSection = ref1[0], setCurrentSection = ref1[1];
    var ref2 = useState([]), headings = ref2[0], setHeadings = ref2[1];
    var registerHeading = useCallback(function(id, top) {
        setHeadings(function(headings) {
            return _to_consumable_array(headings.filter(function(h) {
                return id !== h.id;
            })).concat([
                {
                    id: id,
                    top: top
                }
            ]);
        });
    }, []);
    var unregisterHeading = useCallback(function(id) {
        setHeadings(function(headings) {
            return headings.filter(function(h) {
                return id !== h.id;
            });
        });
    }, []);
    useEffect(function() {
        var onScroll = function onScroll() {
            var y = window.pageYOffset;
            var windowHeight = window.innerHeight;
            var sortedHeadings = headings.concat([]).sort(function(a, b) {
                return a.top - b.top;
            });
            if (y <= 0) {
                setCurrentSection(sortedHeadings[0].id);
                return;
            }
            if (y + windowHeight >= document.body.scrollHeight) {
                setCurrentSection(sortedHeadings[sortedHeadings.length - 1].id);
                return;
            }
            var middle = y + windowHeight / 2;
            var current = sortedHeadings[0].id;
            for(var i = 0; i < sortedHeadings.length; i++){
                if (middle >= sortedHeadings[i].top) {
                    current = sortedHeadings[i].id;
                }
            }
            setCurrentSection(current);
        };
        if (tableOfContents.length === 0 || headings.length === 0) return;
        window.addEventListener("scroll", onScroll, {
            capture: true,
            passive: true
        });
        onScroll();
        return function() {
            return window.removeEventListener("scroll", onScroll, true);
        };
    }, [
        headings,
        tableOfContents
    ]);
    return {
        currentSection: currentSection,
        registerHeading: registerHeading,
        unregisterHeading: unregisterHeading
    };
}
function ContentsLayoutOuter(_param) {
    var children = _param.children, layoutProps = _param.layoutProps, props = _object_without_properties(_param, [
        "children",
        "layoutProps"
    ]);
    var ref = useTableOfContents(layoutProps.tableOfContents), currentSection = ref.currentSection, registerHeading = ref.registerHeading, unregisterHeading = ref.unregisterHeading;
    return /*#__PURE__*/ _jsx(SidebarLayout, _object_spread_props(_object_spread({
        sidebar: /*#__PURE__*/ _jsx("div", {
            className: "mb-8",
            children: /*#__PURE__*/ _jsx(TableOfContents, {
                tableOfContents: layoutProps.tableOfContents,
                currentSection: currentSection
            })
        })
    }, props), {
        children: /*#__PURE__*/ _jsx(ContentsContext.Provider, {
            value: {
                registerHeading: registerHeading,
                unregisterHeading: unregisterHeading
            },
            children: children
        })
    }));
}
function setupPagesLayout(param) {
    var children = param.children, meta = param.meta, classes = param.classes, tableOfContents = param.tableOfContents, section = param.section;
    var router = useRouter();
    var toc = _to_consumable_array(classes ? [
        {
            title: "Quick reference",
            slug: "class-reference",
            children: []
        }
    ] : []).concat(_to_consumable_array(tableOfContents));
    var ref = useTableOfContents(toc), currentSection = ref.currentSection, registerHeading = ref.registerHeading, unregisterHeading = ref.unregisterHeading;
    var ref1 = usePrevNext(), prev = ref1.prev, next = ref1.next;
    return /*#__PURE__*/ _jsxs("div", {
        className: "max-w-3xl mx-auto pt-5 xl:max-w-none xl:ml-0 xl:mr-[15.5rem] xl:pr-16",
        children: [
            /*#__PURE__*/ _jsx(PageHeader, {
                title: meta.title,
                description: meta.description,
                badge: {
                    key: "Tailwind CSS version",
                    value: meta.featureVersion
                },
                section: section
            }),
            /*#__PURE__*/ _jsxs(ContentsContext.Provider, {
                value: {
                    registerHeading: registerHeading,
                    unregisterHeading: unregisterHeading
                },
                children: [
                    classes ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(ClassTable, _object_spread({}, classes)),
                            /*#__PURE__*/ _jsx("div", {
                                id: "content",
                                className: "relative z-20 prose mt-12",
                                children: /*#__PURE__*/ _jsx(MDXProvider, {
                                    components: {
                                        Heading: Heading
                                    },
                                    children: children
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ _jsx("div", {
                        id: "content",
                        className: "relative z-20 prose mt-8",
                        children: /*#__PURE__*/ _jsx(MDXProvider, {
                            components: {
                                Heading: Heading
                            },
                            children: children
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx(DocsNewsletter, {})
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "fixed z-20 top-[3.8125rem] bottom-0 right-[max(0px,calc(50%-45rem))] w-[19.5rem] py-10 px-8 overflow-y-auto hidden xl:block",
                children: toc.length > 0 && /*#__PURE__*/ _jsx(TableOfContents, {
                    tableOfContents: toc,
                    currentSection: currentSection
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/layouts/SetupDocsLayout.js + 1 modules
var SetupDocsLayout = __webpack_require__(25812);
;// CONCATENATED MODULE: ./src/pages/docs/setup/index.js








function TailwindCli(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InstallationLayout/* InstallationLayout */.l, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "relative z-10 prose mb-16 max-w-3xl",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "The simplest and fastest way to get up and running with your apps\uD83C\uDFD5 without making a big effort is using our pre-built apps. Fit perfectly for someone who is trying to validate the idea and also totally new to this space.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "pl-5",
                        children: " - You have an idea and want to quickly go to the market."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "pl-5",
                        children: [
                            " ",
                            "- You might want to start first with MVP and customise the solution as per the idea validation results.",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "pl-5",
                        children: [
                            " ",
                            "- Every new signup would get an web app \uD83C\uDFD5 hosted on our server. So, you can get a glimpse of your project, And test functionalities. The url is hosted under “APPNAME.tradly.co”"
                        ]
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "We try to test & cover as many deployment platforms as possible through documentations,",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://tradly.app/docs/netlify",
                        target: "_blank",
                        children: "check here"
                    }),
                    ". but with Vercel we have native integrations."
                ]
            })
        })
    });
}
TailwindCli.layoutProps = {
    meta: {
        title: "Tradly Documentation - 2024"
    },
    Layout: SetupDocsLayout/* SetupDocumentationLayout */.Y,
    allowOverflow: false
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [73320,85220,96401,17114,48777,26852,5679,83019,82536,49774,92888,40179], function() { return __webpack_exec__(25508); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);